import { render } from "./Dialog.vue?vue&type=template&id=48cfd832"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=48cfd832&lang=css"
script.render = render

export default script